import { withControlledField } from '../ControlledField';
import { TextFieldWrapper } from './TextFieldWrapper';

export const ControlledTextField = withControlledField(TextFieldWrapper);
